import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '../../services/notifications.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { BaseService } from '../../services/base.service';
import moment from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { OlxAdvertService } from '../../services/olx-advert.service';
import { ADVERT_PLANNER_TYPE } from '../../enum/constants';

interface FormDateTime {
  name: FormControl;
  x_data: any;
}

@Component({
  selector: 'app-advert-plain',
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PlannerComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();

  public isLoader: boolean = false;
  public selected = null;
  public today = new Date();
  public advert_id!: string;
  public channel_id!: string;
  public adverts!: string[];
  public planner_id!: string;
  public planners: string[] = [];

  public advert: any = {};
  public type: any;
  public modalType = '';
  public info: any;

  formPlanner!: FormGroup<FormDateTime>;

  eachTimes = [
    { name: '0m', value: '0' },
    { name: '5m', value: '5' },
    { name: '10m', value: '10' },
    { name: '15m', value: '15' },
    { name: '30m', value: '30' },
    { name: '45m', value: '45' },
    { name: '1h', value: '60' },
    { name: '2h', value: '120' },
    { name: '3h', value: '180' },
  ];

  typePlanners = [
    { name: ADVERT_PLANNER_TYPE.ACTIVATION, value: 'ACTIVATION' },
    { name: ADVERT_PLANNER_TYPE.DEACTIVATION, value: 'DEACTIVATION' },
    { name: ADVERT_PLANNER_TYPE.PUSH_UP, value: 'PUSH_UP' },
    { name: ADVERT_PLANNER_TYPE.CREATE_ADVERT, value: 'CREATE_ADVERT' },
    { name: ADVERT_PLANNER_TYPE.ADS, value: 'ADS' },
    { name: ADVERT_PLANNER_TYPE.PACKET, value: 'PACKET' },
  ];

  statusPlanners = [
    { name: 'Чорновик', value: 'DRAFT' },
    { name: 'Активний', value: 'WAITING' },
  ];

  constructor(
    public modalService: ModalService,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<PlannerComponent>,
    public readonly baseService: BaseService,
    private readonly olxAdvertService: OlxAdvertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.modalType = this.data.data.modalType;
    this.type = this.data.data.type;
    this.advert_id = data?.data?.advert_id;
    this.adverts = data?.data?.adverts;
    this.planners = data?.data?.planners || [];
    this.channel_id = data?.data?.channel_id;
    this.planner_id = data?.data?.planner_id;
    this.advert = data?.data?.advert;
    this.info = data?.data?.info;
  }

  ngOnInit(): void {
    this.onInitForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private onInitForm(planner?: any): void {
    this.formPlanner = new FormGroup<FormDateTime>({
      name: new FormControl(this.info?.name || planner?.name || null, [Validators.required]),
      x_data: new FormGroup({
        type: new FormControl(
          planner?.type || this.info?.type_planner || null,
          !this.planners?.length && this.modalType === 'ADVERT' ? [Validators.required] : [],
        ),
        status: new FormControl(
          planner?.status || this.info?.status || 'WAITING',
          !this.planners?.length ? [Validators.required] : [],
        ),
        date: new FormControl(planner?.planned_at || this.info?.planned_at || '', [Validators.required]),
        time: new FormControl(
          moment(planner?.planned_at).format('HH:mm') || moment(this.info?.type).format('HH:mm') || '',
          [Validators.required, Validators.minLength(5)],
        ),
        step: new FormControl('0', []),
      }),
    });
  }

  onSave() {
    this.dialogRef.close(this.formPlanner.getRawValue());
  }

  addDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.formPlanner.controls.x_data.date.patchValue(event.value);
  }

  onClose() {
    this.dialogRef.close();
  }
}
